import React from 'react';

import { ForecastPaginatedActions } from 'src/features/forecastPaginated/forecastPaginatedActions/ForecastPaginatedActions';
import { ForecastPaginatedActionsSkeleton } from 'src/features/forecastPaginated/forecastPaginatedActions/ForecastPaginatedActionsSkeleton';

type ForecastPaginatedActionsContainerProps = {
  isLoading: boolean;
  hasPrevious: boolean;
  hasNext: boolean;
  sessionId?: string;
  sku?: string | null;
  isDestocking?: boolean;
  totalProducts?: number;
  validatedNumber: number;
  validatedAt?: string | null;
  handlePrevious: () => void;
  handleNext: () => void;
  handleReset: () => void;
};

export function ForecastPaginatedActionsContainer({
  isLoading,
  hasPrevious,
  hasNext,
  sessionId,
  sku,
  isDestocking,
  totalProducts,
  validatedNumber,
  validatedAt,
  handlePrevious,
  handleNext,
  handleReset,
}: ForecastPaginatedActionsContainerProps) {
  return (
    <>
      {totalProducts !== undefined && !isLoading && sku && sessionId ? (
        <ForecastPaginatedActions
          sessionId={sessionId}
          isLoading={isLoading}
          hasPrevious={hasPrevious}
          hasNext={hasNext}
          sku={sku}
          isDestocking={isDestocking}
          totalProducts={totalProducts}
          validatedNumber={validatedNumber}
          validatedAt={validatedAt}
          handlePrevious={handlePrevious}
          handleNext={handleNext}
          handleReset={handleReset}
        />
      ) : (
        <ForecastPaginatedActionsSkeleton />
      )}
    </>
  );
}
